import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cha",
  "use": "cha-usage",
  "viewBox": "0 0 66 66",
  "content": "<symbol viewBox=\"0 0 66 66\" id=\"cha\"><defs><style>#cha .cls-1{fill-rule:evenodd;}</style></defs><title>资源 115</title><g id=\"cha_图层_2\" data-name=\"图层 2\"><g id=\"cha_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M33,0A33,33,0,1,0,66,33,33,33,0,0,0,33,0ZM47.26,43.7a2.52,2.52,0,0,1-3.57,3.57L33,36.57,22.3,47.26a2.52,2.52,0,0,1-3.57-3.57L29.43,33,18.74,22.3a2.52,2.52,0,0,1,3.57-3.57L33,29.43l10.7-10.7a2.52,2.52,0,0,1,3.57,3.57L36.57,33Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/cha.svg
// module id = H4fz
// module chunks = 264